import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';


const AcknowledgedAnnouncement = () => {
    const {id} = useParams();
    const [announcements, setAnnouncements] = useState([]);

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const fetchAnnouncements = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/getAcknowledgedAnnouncements/${id}`);
            setAnnouncements(response.data.data);
        } catch (error) {
            console.error("Error fetching announcements", error);
            setAnnouncements([]);
        }
    };
      
    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Announcements {new Date().getFullYear()}</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item"><Link to="/announcements">Announcements</Link></li>
                                <li className="breadcrumb-item active">Acknowledged Announcements</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="/announcements" className="btn add-btn">
                                <i className="fa-solid fa-arrow-left"></i> Back</Link>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Employees</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                announcements.length > 0 ? (
                                                    announcements.map((announcement, index) => (
                                                        <tr key={announcement.id}>
                                                            <td>{++index || ''}</td>
                                                            <td>{announcement.date || ''}</td>
                                                            <td>{announcement.user_name || ''}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No acknowledged record found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AcknowledgedAnnouncement